const admin = {
    title: '管理',
    description: 'システム設定、ユーザー、アクティビティを管理します。',
    users: 'ユーザー管理',
    usersDescription: 'ユーザー、ロール、権限を管理',
    groups: 'グループ管理',
    categories: 'カテゴリー管理',
    tags: 'タグ管理',
    permissions: '権限管理',
    auditLogs: '監査ログ',
    auditLogsDescription: 'システム監査ログを表示',
    settings: 'システム設定',
    settingsDescription: 'システム全体の設定を構成',
    systemHealth: 'システム状態',
    storage: 'ストレージ管理',
    storageDescription: 'ストレージ使用量と割り当てを監視',
    security: 'セキュリティ',
    securityDescription: 'セキュリティ設定とアクセス制御',
    analytics: '分析',
    analyticsDescription: 'システム使用状況の分析とレポート',
    activityAudit: 'アクティビティ監査',
    activityAuditDescription: 'テナントの全ユーザーアクティビティをダッシュボードで確認 (#579)',
    anomalies: '不審行為一覧',
    anomaliesDescription: '連続ログイン失敗・テナント越境などの不審シグナルを確認 (#578)',
    noPermission: '管理機能へのアクセス権限がありません。',
  };

export default admin;
